<template>
  <div class="text-center">
    <v-bottom-sheet v-model="visible">
      <v-sheet class="text-center" height="200px">
        <div style="position:relative;padding-top:0.8rem;">
            <span>
              <span>设备恢复码</span>
            </span>
            <span style="position:absolute;right:10px;top:10px;"><v-icon size="27" @click="visible=false">mdi-close</v-icon></span>
        </div>
        <div style="margin-top:0.5rem;">
          <span style="font-size:45px;letter-spacing: 20px;">{{regainCode}}</span>
        </div>
        <div style="font-size:0.85rem;padding-top:1rem;">
          此码在运维主机使用，只能使用一次，有效期30分钟。
        </div>

      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    regainCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {},
  mounted() {
  },
  created() {
  },
  methods: {
    show() {
      var that = this
      that.visible = true
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
</style>

